import { render, staticRenderFns } from "./CreateVirtualAliasModal.vue?vue&type=template&id=d4e7b48e&"
import script from "./CreateVirtualAliasModal.vue?vue&type=script&lang=js&"
export * from "./CreateVirtualAliasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports